import React, { useEffect, useState } from 'react';

import * as Styles from './_marketStatusStyles.module.scss';
import ActionButton from '~components/atoms/ActionButton';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import LabelledInput from '~components/atoms/LabelledInput';
import { BranchStatusEnum, MarketStatusEnum, ModuleEnum, PermissionsEnum } from '~utils/enums';
import dayjs from 'dayjs';
import TabPageContainer from '~components/atoms/TabPageContainer';
import TabPageHeaderWrapper from '~components/atoms/TabPageHeaderWrapper';
import ConfirmUpdateMarketStatusModal from './ConfirmUpdateMarketStatusModal';
import ConfirmUpdateMarketStatusCloseModal from './ConfirmUpdateMarketStatusCloseModal';
import LabelledDropdown from '~components/atoms/LabelledDropdown';
import { TDropdownOption } from '~types/components/labelledDropdown';

const MarketStatus = () => {
    const dispatch = useAppDispatch();

    const marketHourStatus = useAppSelector(state => state.gold.goldBranchMarketStatusDetails);

    const userAccess = useAppSelector(state => state.auth.userDetails.access);

    const editAccessModules = userAccess.find(access => access.permission === PermissionsEnum.Edit)?.modules || [];

    const branchesList = useAppSelector((state) => state.branch.allBranches);
    const { allBranchAccess } = useAppSelector(state => state.auth.userDetails);

    const [branchName, setBranchName] = useState('');
    const [branchCode, setBranchCode] = useState('');

    useEffect(() => {
        if (!branchCode) return;

        dispatch(combinedActions.goldGetBranchMarketStatusAttempt({ branchCode }));
    }, [branchCode]);

    const handleOpenMarketClicked = () => {
        dispatch(combinedActions.dashboardIsMarketStatusOpenConfimationModalOpen(true));
    };

    const handleCloseMarketClicked = () => {
        dispatch(combinedActions.dashboardIsMarketStatusCloseConfirmationModalOpen(true));
    };

    const branchOptions = branchesList.filter(branch => branch.status === BranchStatusEnum.Active).map((branch) => ({
        label: branch.branchName,
        value: branch.branchCode,
    }));

    const handleOnSearchBranch = (event: React.ChangeEvent<HTMLInputElement>) => {
        setBranchName(event.target.value);
    };

    const handleOnSelectBranch = (option: TDropdownOption) => {
        setBranchCode(String(option.value));
    };

    const isBranchSelected = !!branchCode;

    return (
        <TabPageContainer>
            <TabPageHeaderWrapper>

            </TabPageHeaderWrapper>

            <div className={Styles.container}>

                {
                    editAccessModules.find(module => module === ModuleEnum.MarketStatus) && (
                        <div className={Styles['action-container']}>
                            <div title={!isBranchSelected ? 'Please select a branch first' : ''}>
                                <ActionButton
                                    className={Styles['edit-button']}
                                    label='Open Market'
                                    onClick={handleOpenMarketClicked}
                                    disabled={marketHourStatus.status === MarketStatusEnum.Open || !isBranchSelected}
                                />
                            </div>

                            <div title={!isBranchSelected ? 'Please select a branch first' : ''}>
                                <ActionButton
                                    className={Styles['edit-button']}
                                    label='Close Market'
                                    onClick={handleCloseMarketClicked}
                                    disabled={marketHourStatus.status === MarketStatusEnum.Close || !isBranchSelected}
                                />
                            </div>
                        </div>
                    )
                }

                <form className={Styles['form-container']}>
                    <div className={Styles['form-branch']}>
                        <LabelledDropdown
                            id='branchName'
                            name='branchName'
                            label='Branch*: '
                            placeholder='Please select branch'
                            options={branchOptions}
                            value={branchName}
                            onChange={handleOnSearchBranch}
                            onSelectOption={handleOnSelectBranch}
                            noOptionsMessage='No branches found'
                            autoComplete='off'
                            optionSelected={!!branchOptions.find((branch) => branch.label === branchName)}
                            disabled={!allBranchAccess}
                        />

                        <LabelledInput
                            id='branchCode'
                            name='branchCode'
                            label='Branch Code* :'
                            value={branchCode}
                            disabled
                        />
                    </div>
                    <div className={Styles['form-subcontainer']}>
                        <div>Market Status</div>
                        <LabelledInput
                            id='endDate'
                            name='endDate'
                            label=':'
                            value={branchCode ? MarketStatusEnum[marketHourStatus.status] : ''}
                            disabled={true}
                            isRow
                        />

                        <div>Market Time</div>

                        <LabelledInput
                            id='apiKey'
                            name='apiKey'
                            label=':'
                            value={
                                branchCode && marketHourStatus.currentTime
                                    ? dayjs(marketHourStatus.currentTime).format('DD/MM/YYYY hh:mm A')
                                    : ''
                            }
                            disabled={true}
                            isRow
                        />
                    </div>
                </form>
            </div>

            <ConfirmUpdateMarketStatusModal branchCode={branchCode} />
            <ConfirmUpdateMarketStatusCloseModal branchCode={branchCode} />
        </TabPageContainer>

    );
};

export default MarketStatus;
